import React, {useEffect, useState} from 'react'
import { useParams,useNavigate } from 'react-router-dom'; // import useLocation
import './TheTrustCard.css';

const TheTrustCard = (selectedMenu) => {
    const navigate = useNavigate(); // React Router 的导航钩子
    const { selectedOption } = useParams();
    const decodedOption = decodeURIComponent(selectedOption);
    const [selectedContent, setSelectedContent] = useState(decodedOption===""? 0:decodedOption-"");
    const handleStepNextClick = (value) => {
        setSelectedContent(selectedContent+value);
    };

    const clickSubMenu = (value) => {
        setSelectedContent(value);
        setActiveOptionIndex(null);
        if(isNaN(value)){
            //value不是数字,则返回true ,则是需要转到其他页面去
            //for eg.   TheFoundation-1
            navigate("/"+value.split("-")[0]+"/"+value.split("-")[1]); // 跳转到指定的 URL
        } else{
            //value是数字,则返回false,则只需要当前页面转即可
            //The vision page now no need to redirect to other page
        }
    };
    // 滚动到顶部
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth", // 平滑滚动
        });
    };


    const handleButtonClick = (url) => {
        window.open(url, '_blank');
    };


    // 当前选中的页码
    const [currentPage, setCurrentPage] = useState(1);

    // 当前展开子菜单的选项索引
    const [activeOptionIndex, setActiveOptionIndex] = useState(null);

    // 每个页面对应的内容和子菜单
    const pages = [
        {
            options: [
                { name: "About The Trust Wai 262", subMenu: ["Legal Status of the Trust", "Ko Matou -Nga Rangatahi Succession Planning-Presentand Future Leaders)"] ,
                    subDiv:[0,1]
                },
                { name: "The Vision,Mission and Core Values of the Trust", subMenu: ["Vision, Mission, and Core Values"],
                    subDiv:["TheVisionAndMission-0"]
                },
            ]
        },
        {
            options: [
                { name: "The Foundation(Pou) of the Trust ", subMenu: ["He Wakaputanga 1835 ((Declaration of Independence)-Articles 1 to 4", "Te Tiriti o Waitangi","Te Ao Māori Views","Tino Rangatiratanga"],
                    subDiv:["TheFoundation-0","TheFoundation-1","TheFoundation-2","TheFoundation-3"]
                    },
                { name: "Wai 262 Flora and Fauna Claim",
                    subMenu: [
                        "What is Wai 262",
                        "When did the claim begin? and why?",
                        "Profile of Claimants",
                        "Waitangi Tribunal's recommendations for the Wai 262flora and fauna claim",
                        "New Zealand's Government's Strategic Approach",
                        "Taonga introduced for Protection",
                        "About The Wai 262 Flora and Fauna Claim",
                        "The Wai 262 Report Released by The Waitangi Tribunal",
                        "What Did the Waitangi Tribunal Report Say About theWai 262 Claim?",
                        "The Waitangi Tribunal Reccomendations",
                    ] },
            ]
        },
        {
            options: [
                { name: "Contemporary Wai 262",
                    subMenu: ["The Wai 262 Contemporary Aspects of the Claim Today",
                        "Flora Taonga",
                        "Fauna Taonga",
                        "Flora and Fauna Taonga - Conclusion",
                        "Protection and Management Plan for Wai 262 Flora and FaunaContemporary Taonga",
                    ] },
                { name: "Association of New Zealand Government", subMenu: ["Sub B3-1", "Sub B3-2"] },
            ]
        },
        {
            options: [
                { name: "New Zealand Legislative Acts", subMenu: ["Sub A4-1", "Sub A4-2"] },
                { name: "International Instruments", subMenu: ["International Instruments in Association with the Wai 262-Year 1800 to Year 2024"] },
            ]
        },
        {
            options: [
                { name: "Al and Cyber Security impacts", subMenu: ["Sub A5-1", "Sub A5-2"] },
                { name: "Wai 262 Contemporary - Food Sovereignty", subMenu: ["Sub B5-1", "Sub B5-2"] },
            ]
        },
        {
            options: [
                { name: "Information Library", subMenu: ["Library Sub 1", "Library Sub 2"] },
                { name: "User Registration", subMenu: ["Registration Sub 1", "Registration Sub 2"] },
            ]
        },
        {
            options: [
                { name: "Donation for Support", subMenu: ["Library Sub 1", "Library Sub 2"] },
                { name: "Information Request", subMenu: ["Registration Sub 1", "Registration Sub 2"] },
            ]
        },
        {
            options: [
                { name: "Clothing Merchandise", subMenu: ["Sub 1", "Sub 2"] },
            ]
        },
    ];

    // 处理点击选项事件
    const handleOptionClick = (index) => {
        setActiveOptionIndex(index === activeOptionIndex ? null : index); // 点击相同选项收起子菜单
    };


    // 监听滚动事件
    useEffect(() => {

    }, []);
    return (
        <>
        <div className="pou-container">
            <div className="imgTrust-container">
                <h1 className="h1AboutTrust-container">
                    About the Trust
                </h1>
                <br/>
                <div className="textTrust-container">
                    Learn about the organisation`s role within the Wai 262 movement,learn about Te Tiriti O Waitangi and the concepts of He Whakaputanga.
                </div>
            </div>

            <div className="options">
                {pages[currentPage - 1].options.map((option, index) => (
                    <div key={index} className="option-box">
                        <div onClick={() => handleOptionClick(index)}>{option.name}</div>
                        {/* 子菜单 */}
                        {activeOptionIndex === index && (
                            <div className="sub-menu-floating">
                                {option.subMenu.map((sub, subIndex) => (
                                    <div key={subIndex} className="sub-menu-item" onClick={(e) => clickSubMenu(option.subDiv[subIndex])}>
                                        {sub}
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                ))}
            </div>
            {/* 分页点 */}
            <div className="pagination">
                {pages.map((_, index) => (
                    <div
                        key={index}
                        className={`dot ${currentPage === index + 1 ? "active" : ""}`}
                        onClick={() => {
                            setCurrentPage(index + 1);
                            setActiveOptionIndex(null); // 切换页面时关闭子菜单
                        }}
                    ></div>
                ))}
            </div>



            <div className="the-trust-container" style={{
                display:selectedContent===0?"block":"none"
            }}>
                <div className="legal-status-container">
                    <h1 className="legal-title">Legal Status of The Trust</h1>
                    <p className="legal-description">
                        The full legal name of the Trust is Tiaki Tanga Trust Wai 262 and was
                        established in 2016. The Trust is an incorporated society/non-profitable,
                        Charitable organisation based in the Hokianga, Far North.
                    </p>

                    {/* Image Section */}
                    <div className="image-container">
                    </div>

                    {/* Subsection */}
                    <h2 className="ko-matou-title">Ko Matou – Nga Rangatira</h2>
                    <p className="ko-matou-description">
                        Te Ao Māori refers to the Māori worldview, which encompasses Māori beliefs,
                        values, and customs. It includes concepts such as whakapapa (genealogy),
                        tikanga (customs and traditions), and mana (authority and spiritual power).
                    </p>
                </div>
            </div>
            <div className="pou-container3"  style={{
                display:selectedContent===1?"block":"none"
            }}>
                <div className="succession-container">
                    {/* Main Title */}
                    <h1 className="succession-title">Ko Matou - Nga Rangatahi Succession Planning</h1>
                    <h2 className="succession-subtitle">Present and Future Leaders</h2>

                    {/* Content Section */}
                    <div className="content-wrapper">
                        {/* Left Content */}
                        <div className="text-section">
                            <h3 className="text-heading">Whakatauki: Ka pu te ruha, Ka hao te rangatahi</h3>
                            <p className="text-body">
                                Generational transition, where the youth (rangatahi) take on roles and responsibilities as the elders
                                (the old net) step back. It symbolizes renewal and the passing of knowledge, skills, and leadership from
                                one generation to the next, with the understanding that the younger generation will bring fresh energy
                                and perspectives to continue the work of their ancestors.
                            </p>

                            <hr className="divider" />

                            <p className="quote">“Makere atu te kupenga tawhito kia haere te kupenga hou ki te hi ika, engari me pātai te kupenga hou ki te kupenga tawhito kei hea ngā ika.”</p>
                            <p className="quote-translation">
                                Cast the old net aside to let the new net go fishing, however the new net needs to ask the old net where
                                the fish are?
                            </p>

                            <hr className="divider" />

                            <p className="quote">“Mā te hononga o te mātauranga o mua me ngā pūkenga o naianei e whakakaha ai, e whai oranga tonutanga ai te iwi Māori mō āpōpō me ngā rā e heke mai nei.”</p>
                            <p className="quote-translation">
                                While the new generation takes on the responsibilities, it must still seek guidance from the knowledge of
                                the elders. The combined wisdom of past and present to strengthen and ensure the long-term resilience and
                                sustainability of Māori today and for future generations.
                            </p>
                        </div>

                        {/* Right Content */}
                        <div className="image-section">
                        </div>
                    </div>
                </div>
            </div>


            <div className="nextAndPre">
                {selectedContent !== 0  && (
                    <label onClick={() => handleStepNextClick(-1)}>Pre </label>
                )}
                <label onClick={() => handleStepNextClick(1)}>
                    {selectedContent === 0  && (
                        <label> Next </label>
                    )}
                 </label>
            </div>
            <div
                className="scroll-div"
                onClick={scrollToTop} // 点击事件
                title="Scroll back to top" // 鼠标悬浮提示
            ></div>
        </div>
        </>

  );
}

export default TheTrustCard